import { render } from "./PlanSales.vue?vue&type=template&id=19689c36"
import script from "./PlanSales.vue?vue&type=script&lang=js"
export * from "./PlanSales.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__